import { render } from "./SourceOrder.vue?vue&type=template&id=1a55fcd5&scoped=true&ts=true"
import script from "./SourceOrder.vue?vue&type=script&lang=ts"
export * from "./SourceOrder.vue?vue&type=script&lang=ts"

import "./SourceOrder.vue?vue&type=style&index=0&id=1a55fcd5&lang=scss&scoped=true"

import exportComponent from "C:\\TeamCityBuildAgent\\work\\623dcfb411009e26\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a55fcd5"]])

export default __exports__